<template>
  <div class="redirect-modal-wrapper">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">Weiterleiten</div>
      <div class="content">
        <div class="url-inputs">
          <label for="success-url" style="margin-right: 15px"
            >Weiterleiten nach</label
          >
          <input
            type="text"
            name="success-url"
            v-model="task.props.redirect"
            placeholder="https://codelos.io/success"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Redirect',
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  props: {
    task: Object,
  },
};
</script>
<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.redirect-modal-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.redirect-modal-wrapper .content {
  text-align: center;
  margin-top: 36px;
}
.redirect-modal-wrapper .html {
  margin-top: -100px;
  margin-bottom: 100px;
  margin-right: 14%;
  height: 250px;
}

.redirect-modal-wrapper .content > h1 {
  margin-top: 0px;
  color: #333c4e;
  font-weight: 300;
}

.redirect-modal-wrapper .pull-right {
  float: right;
}

.redirect-modal-wrapper button.pull-right {
  margin-right: 0px;
}

.redirect-modal-wrapper .modal .btn-close {
  margin-top: -60px;
  margin-right: -10px;
}

.redirect-modal-wrapper .btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 0;
  margin-top: 25px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.redirect-modal-wrapper .btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

.redirect-modal-wrapper label {
  float: left;
}
.redirect-modal-wrapper .url-inputs {
  gap: 15px;
  align-items: center;
  margin-bottom: 135px;

  display: flex;
  justify-content: flex-start;
}

.redirect-modal-wrapper .url-inputs label {
  font-size: 16px;
  color: #151515;
  min-width: 220px;
  text-align: left;
}
.redirect-modal-wrapper .url-inputs input {
  font-size: 18px !important;
  width: 300px !important;
  color: #a9a9a9 !important;
  outline: none !important;
}
</style>
